import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LatestEpisodes } from "@/components/LatestEpisodes";
import { VideoSection } from "@/components/VideoSection";
import { TeamSection } from "@/components/TeamSection";
import { JoinCTA } from "@/components/JoinCTA";
import { RandomPick } from "@/components/RandomPick";
import { Testimonials } from "@/components/Testimonials";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="home-page">
      <Navbar />
      <main className="flex-1">
        <LatestEpisodes />
        <VideoSection />
        <TeamSection />
        <JoinCTA />
        <RandomPick />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
